var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-0 bg-white ",staticStyle:{"max-width":"100%","width":"100%"}},[_c(_vm.userComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }